import { COURSE_FORM_TYPES } from "consts";
import { useEffect, useState } from "react";
import { CourseFormApi, CourseFormFieldApi, courseformsApi } from "./courseformsApi";

export interface CourseFormGroupedFields {
  id: number;
  type: number;
  groups: {
    name: string;
    fields: CourseFormFieldApi[];
  }[];
}

export const useCourseApplicationForm = (courseId?: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CourseFormApi | null>(null);

  const fetchCourseForms = async (): Promise<CourseFormApi | null> => {
    if (!courseId) {
      console.error("Course id not found.");
      setLoading(false);
      return null;
    }
    const res = await courseformsApi.fetchByType(courseId, COURSE_FORM_TYPES.APPLICATION);
    try {
      setData(res.data[0]); // todo validation if lenght != 1
      return res.data[0];
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
    return null;
  };

  useEffect(() => {
    fetchCourseForms();
  }, [courseId]);

  const refresh = async (callback?: (data: CourseFormApi | null) => Promise<void>) => {
    setLoading(true);
    const resp = await fetchCourseForms();
    if (callback) await callback(resp);
  };

  return { loading, data, refresh };
};
